/*
* @描述: 商机详情页
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-06 17:07:24
*/
<template>
    <div v-loading="loading" class="page_container">
        <div class="detail_outer_wrap">
            <div class="left_detail_board">
                <div class="detail_top_wrap">
                    <div v-if="businessStage===-2" class="loser_reason_wrap">
                        <span class="loser_title">输单原因：</span>
                        <span class="loser_text" v-text="projectFormDetail.remarks"></span>
                    </div>
                    <div v-if="businessStage===-3" class="invalid_reason_wrap">
                        <span class="loser_title">无效原因：</span>
                        <span class="loser_text" v-text="projectFormDetail.remarks"></span>
                    </div>
                    <div class="flex_js_wrap">
                        <div class="flex_wrap">
                            <i class="iconfont icon-shangji"></i>
                            <h2 v-if="projectFormDetail.name" v-text="projectFormDetail.name.value"></h2>
                        </div>
                        <div class="flex_wrap">
                            <div v-if="permission['project.edit']" class="detail_handle_icon_wrap"
                                 @click="handleClickEditBusiness">
                                <i class="iconfont icon-bianji"></i>
                                <span>编辑</span>
                            </div>
                            <el-dropdown v-if="permission['project.edit']||hasDelPermission" placement="bottom-end"
                                         trigger="click">
                                <div class="detail_handle_icon_wrap">
                                    <i class="iconfont icon-gengduo"></i>
                                    <span>更多</span>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                            v-if="projectFormDetail.approval_status===1&&permission['project.edit']"
                                            @click.native="handleClickChangeThePerson">更换负责人
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="hasDelPermission" @click.native="handleClickDelBusiness">删除
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="flex_js_wrap m_0">
                        <div class="flex_wrap">
                            <div class="custom_contact_field_wrap">
                                <PersonnelCard v-if="projectFormDetail.salesperson"
                                               :userId="projectFormDetail.salesperson.value[0]">
                                    <template slot="container">
                                        <img :src="projectFormDetail.salesperson.text[0].avatar || defaultImg" alt=""
                                             class="avatar">
                                        <span class="name" v-text="projectFormDetail.salesperson.text[0].name"></span>
                                    </template>
                                </PersonnelCard>
                            </div>
                            <span class="line"></span>
                            <i class="iconfont icon-bumenfuzeren"></i>
                            <span v-if="projectFormDetail.customer_id" class="company_name"
                                  v-text="projectFormDetail.customer_id.text"></span>
                            <span class="line"></span>
                            <span class="create_date" v-text="projectFormDetail.created_at"></span>
                        </div>
                        <el-link :underline="false" type="primary" @click="handleClickElaborateOrRetract">
                            {{ elaborateOrRetract ? '收起详情' : '展开详情' }} <i
                                :class="elaborateOrRetract?'icon-shangjiantou':'icon-xiajiantou'"
                                class="iconfont"></i>
                        </el-link>
                    </div>
                    <div v-if="elaborateOrRetract" class="detail_form_wrap">
                        <CustomFormDetailPc v-if="dataLoaded"
                                            :field_list="formInfoList"
                                            :form_detail="projectFormDetail"
                                            :pk_id="project_id"
                                            :is_edit_mode="false"/>
                    </div>
                    <div v-if="elaborateOrRetract" class="bottom_umbrage"></div>
                </div>
                <div class="detail_bottom_wrap">
                    <div class="bottom_detail_wrap">
                        <div class="page_little_title">商机阶段</div>
                        <div class="business_stage_wrap">
                            <ul class="business_stage_list">
                                <li v-for="(item,index) in projectStagesList"
                                    :key="item.project_stage_id"
                                    :class="{'excessive_current_stage':currentStageData.sort>=item.sort&&businessStage>0,'current_stage':currentStageData.sort===item.sort&&businessStage>0}"
                                    class="business_stage_item"
                                    @click="handleClickStageItem(item)">
                                    <div v-if="businessStage<0" class="stage_end">
                                        <i class="el-icon-check"></i>
                                    </div>
                                    <div v-else class="stage_index" v-text="index+1"></div>
                                    <el-tooltip v-if="item.sort>currentStageData.sort"
                                                content="推进至此阶段"
                                                effect="dark"
                                                placement="top">
                                        <div class="stage_title" v-text="item.name"></div>
                                    </el-tooltip>
                                    <div v-else class="stage_title" v-text="item.name"></div>
                                    <i class="el-icon-arrow-right"></i>
                                </li>
                                <el-dropdown trigger="click">
                                    <li :class="{'current_stage':businessStage<0}"
                                        class="business_stage_item business_end_stage">
                                        <div v-if="businessStage<0" class="stage_end_icon">
                                            <div v-if="businessStage===-1" class="triumph_icon">
                                                <i class="iconfont icon-xiao"></i>
                                            </div>
                                            <div v-if="businessStage===-2" class="failure_icon">
                                                <i class="iconfont icon-ku"></i>
                                            </div>
                                            <div v-if="businessStage===-3" class="invalid_icon">
                                                <i class="iconfont icon-wunai"></i>
                                            </div>
                                        </div>
                                        <div v-else class="stage_index" v-text="projectStagesList.length+1"></div>
                                        <div class="stage_title"><span
                                                v-text="businessStage<0?businessStage===-1?'赢单':businessStage===-2?'输单':'无效商机':'结束'"></span><i
                                                class="el-icon-caret-bottom"></i></div>
                                    </li>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-if="businessStage!==-1"
                                                          @click.native="handleClickBusinessTriumph">
                                            <i class="iconfont icon-xiao"></i>赢单
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="businessStage!==-2"
                                                          @click.native="handleClickBusinessFailure">
                                            <i class="iconfont icon-ku"></i>输单
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="businessStage!==-3"
                                                          @click.native="handleClickBusinessInvalid">
                                            <i class="iconfont icon-wunai"></i>无效商机
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </ul>
                            <el-button
                                    v-if="currentStageData.sort<projectStagesList.length&&businessStage>0&&permission['project.edit']"
                                    :disabled="btnDisabled"
                                    size="mini"
                                    type="primary"
                                    @click="handleClickAdvanceNextStage">推进下一阶段
                            </el-button>
                        </div>
                        <h3 v-if="stageTaskFormShow&&currentStageTaskFieldList.length">阶段任务</h3>
                        <div v-if="stageTaskFormShow" class="business_stage_detail_wrap">
                            <CustomFormDetailPc ref="now_stage_task_detail_form"
                                                :blur_change_mode="currentStageSort<currentStageData.sort"
                                                :field_list="currentStageTaskFieldList"
                                                :form_detail="currentStageTaskFormDetail"
                                                :is_edit_mode="true"
                                                :pk_id="currentProjectStageId"
                                                @submit-form="submitDetailFormData"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right_menu_board">
                <el-popover :visible-arrow="false"
                            placement="left"
                            popper-class="custom_tab_popper"
                            ref="relate_quotation_popover"
                            trigger="click"
                            width="360">
                    <div slot="reference" class="menu_item_wrap" @click="handleClickRelateQuotation">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-50/2c8ccbb43dc5e4c0b9238e5b1fdaf927.png">
                        <div class="menu_item_text">报价单</div>
                    </div>
                    <div class="custom_tab_popper_wrap">
                        <div class="custom_tab_popper_header">
                            <span class="popper_title">报价单{{ `（${relateQuotationList.length}）` }}</span>
                            <el-link v-if="permission['project.edit']"
                                     :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     @click="handleClickAddNewQuotation">新增报价
                            </el-link>
                        </div>
                        <div class="custom_tab_popper_body">
                            <el-skeleton :count="3"
                                         :loading="popoverLoad"
                                         :throttle="500"
                                         animated>
                                <template slot="template">
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="width: 120px" variant="h3"/>
                                        <el-skeleton-item style="width: 52px" variant="h3"/>
                                    </div>
                                    <div class="flex_js_wrap mb_12" style="height: 18px">
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                    </div>
                                    <div class="flex_js_wrap mb_12" style="height: 18px">
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                    </div>
                                </template>
                                <template>
                                    <ul class="relate_quotation_list">
                                        <li v-for="item in relateQuotationList" class="relate_quotation_item">
                                            <div class="flex_js_wrap">
                                                <el-link :underline="false" type="primary"
                                                         @click="handleClickQuotationDetail(item)">
                                                    <i class="iconfont icon-baojiadan mr_4"></i>
                                                    <span v-text="item.quotation_num"></span>
                                                </el-link>
                                                <div :class="'quotation_status_'+item.status"
                                                     class="quotation_status"
                                                     v-text="item.status_name"></div>
                                            </div>
                                            <el-row style="flex-wrap: wrap" type="flex">
                                                <el-col :span="12" class="flex_wrap">
                                                    <span class="form_item_label">报价人：</span>
                                                    <div class="custom_contact_field_wrap">
                                                        <PersonnelCard v-if="item.quoter" :userId="item.quoter">
                                                            <template slot="container">
                                                                <img :src="item.quoter_avatar?item.quoter_avatar:defaultImg"
                                                                     alt=""
                                                                     class="avatar">
                                                                <span class="name" v-text="item.quoter_name"></span>
                                                            </template>
                                                        </PersonnelCard>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <span class="form_item_label">报价金额：</span>
                                                    <span class="form_item_value"
                                                          v-text="item.total_price.value"></span>
                                                </el-col>
                                                <el-col :span="12">
                                                    <span class="form_item_label">报价于：</span>
                                                    <span class="form_item_value" v-text="item.quotation_at"></span>
                                                </el-col>
                                                <el-col :span="12">
                                                    <span class="form_item_label">失效于：</span>
                                                    <span class="form_item_value" v-text="item.expiration_at"></span>
                                                </el-col>
                                            </el-row>
                                        </li>
                                    </ul>
                                </template>
                            </el-skeleton>
                        </div>
                        <div class="custom_tab_popper_footer"></div>
                    </div>
                </el-popover>
                <el-popover :visible-arrow="false"
                            placement="left"
                            popper-class="custom_tab_popper"
                            ref="relate_order_popover"
                            trigger="click"
                            width="360">
                    <div slot="reference" class="menu_item_wrap" @click="handleClickRelateOrder">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-50/d0e047c506a5e4cc6677de84f756c0e0.png">
                        <div class="menu_item_text">订单</div>
                    </div>
                    <div class="custom_tab_popper_wrap">
                        <div class="custom_tab_popper_header">
                            <span class="popper_title">关联订单{{ `（${relateOrderList.length}）` }}</span>
                            <el-link :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     v-auth="'order.edit'"
                                     v-if="projectFormDetail.approval_status===1"
                                     permission_type="customer"
                                     route_name="Order"
                                     @click="handleClickAddOrder">新增订单
                            </el-link>
                        </div>
                        <div class="custom_tab_popper_body">
                            <el-skeleton :count="3"
                                         :loading="popoverLoad"
                                         :throttle="500"
                                         animated>
                                <template slot="template">
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="width: 120px" variant="h3"/>
                                        <el-skeleton-item style="width: 62px" variant="text"/>
                                    </div>
                                    <div class="flex_js_wrap mb_12" style="height: 18px">
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                    </div>
                                </template>
                                <template>
                                    <ul class="relate_quotation_list">
                                        <li v-for="item in relateOrderList" class="relate_quotation_item">
                                            <div class="flex_js_wrap">
                                                <el-link :underline="false"
                                                         type="primary"
                                                         @click="handleClickOrderDetail(item)">
                                                    <i class="iconfont icon-a-dingdan1 mr_4"></i><span
                                                        v-text="item.order_num"></span>
                                                </el-link>
                                                <span class="create_time" v-text="item.create_time"></span>
                                            </div>
                                            <el-row style="flex-wrap: wrap" type="flex">
                                                <el-col :span="12" class="flex_wrap">
                                                    <span class="form_item_label">销售：</span>
                                                    <div class="custom_contact_field_wrap">
                                                        <PersonnelCard :userId="item.salesperson">
                                                            <template slot="container">
                                                                <img :src="item.salesperson_avatar?item.salesperson_avatar:defaultImg"
                                                                     alt=""
                                                                     class="avatar">
                                                                <span class="name"
                                                                      v-text="item.salesperson_name"></span>
                                                            </template>
                                                        </PersonnelCard>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <span class="form_item_label">订单金额：</span>
                                                    <span class="form_item_value" v-text="'￥'+item.total_price"></span>
                                                </el-col>
                                            </el-row>
                                        </li>
                                    </ul>
                                </template>
                            </el-skeleton>
                        </div>
                        <div class="custom_tab_popper_footer"></div>
                    </div>
                </el-popover>
                <el-popover :visible-arrow="false"
                            placement="left"
                            popper-class="custom_tab_popper"
                            ref="relate_work_order_popover"
                            trigger="click"
                            width="360">
                    <div slot="reference" class="menu_item_wrap" @click="handleClickRelateWorkOrder">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-50/ad9882432747fbc23ab09f4560af5206.png">
                        <div class="menu_item_text">工单</div>
                    </div>
                    <div class="custom_tab_popper_wrap">
                        <div class="custom_tab_popper_header">
                            <span class="popper_title">关联工单{{ `（${relateWorkOrderList.length}）` }}</span>
                        </div>
                        <div class="custom_tab_popper_body">
                            <el-skeleton :count="3"
                                         :loading="popoverLoad"
                                         :throttle="500"
                                         animated>
                                <template slot="template">
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="width: 120px" variant="h3"/>
                                        <el-skeleton-item style="width: 62px" variant="text"/>
                                    </div>
                                    <div class="flex_js_wrap mb_12" style="height: 18px">
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                        <el-skeleton-item style="width: 40%" variant="text"/>
                                    </div>
                                </template>
                                <template>
                                    <ul class="relate_quotation_list">
                                        <li v-for="item in relateWorkOrderList" class="relate_quotation_item">
                                            <div class="flex_js_wrap">
                                                <div class="flex_wrap">
                                                    <el-link :underline="false" type="primary"
                                                             @click="handleClickWorkOrderDetail(item)">
                                                        <i class="iconfont icon-a-dingdan1 mr_4"></i><span
                                                            v-text="item.workorder_num"></span></el-link>
                                                    <div :class="'quotation_status_'+item.status"
                                                         class="quotation_status"
                                                         v-text="item.status_text"></div>
                                                </div>
                                                <span v-if="item.workorder_type_id" class="create_time"
                                                      v-text="item.workorder_type_id.text"></span>
                                            </div>
                                            <div class="form_item_value mt_4" v-text="item.work_order_type"></div>
                                        </li>
                                    </ul>
                                </template>
                            </el-skeleton>
                        </div>
                        <div class="custom_tab_popper_footer"></div>
                    </div>
                </el-popover>
                <el-popover :visible-arrow="false"
                            placement="left"
                            popper-class="custom_tab_popper"
                            ref="team_members_popover"
                            trigger="click"
                            width="360">
                    <div slot="reference" class="menu_item_wrap" @click="handleClickTeamMember">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-50/2a55ae09d29fcff10d5b9b3b7ce88d53.png">
                        <div class="menu_item_text">团队成员</div>
                    </div>
                    <div class="custom_tab_popper_wrap">
                        <div class="custom_tab_popper_header">
                            <span class="popper_title">团队成员</span>
                            <el-link :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     v-if="permission['project.edit']&&projectFormDetail.approval_status===1"
                                     @click="handleClickAddTeamMember">添加成员
                            </el-link>
                        </div>
                        <div class="custom_tab_popper_body">
                            <el-skeleton :count="5"
                                         :loading="popoverLoad"
                                         :throttle="500"
                                         animated>
                                <template slot="template">
                                    <el-skeleton-item style="width: 100%" variant="h1"/>
                                </template>
                                <template>
                                    <ul class="team_members_list">
                                        <li v-for="(item,index) in teamMembersList" class="team_members_item">
                                            <div class="flex_js_wrap">
                                                <el-popover :visible-arrow="false"
                                                            placement="bottom-start"
                                                            popper-class="user_card_popper"
                                                            trigger="hover"
                                                            width="282">
                                                    <template slot="reference">
                                                        <div class="user-avatar-btn">
                                                            <img :src="item.user_avatar?item.user_avatar:defaultImg"
                                                                 alt=""/>
                                                            <span v-text="item.user_name"></span>
                                                        </div>
                                                    </template>
                                                    <PersonnelCard :userInfo="userInfo"/>
                                                </el-popover>
                                                <div class="flex_wrap">
                                                    <el-radio-group v-model="item.auth"
                                                                    :disabled="!permission['project.edit']"
                                                                    @change="handleMemberAuthChange(item)">
                                                        <el-radio :label="1">只读</el-radio>
                                                        <el-radio :label="2">读写</el-radio>
                                                    </el-radio-group>
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                          v-if="permission['project.edit']"
                                                          @click="handleClickDeleteTeamMember(item)">
                                                        <i class="iconfont icon-shanchu1"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </el-skeleton>
                        </div>
                        <div class="custom_tab_popper_footer"></div>
                    </div>
                </el-popover>
                <el-popover :visible-arrow="false"
                            placement="left"
                            popper-class="custom_tab_popper"
                            ref="follow_up_dynamics_popover"
                            trigger="click"
                            width="360">
                    <div slot="reference" class="menu_item_wrap" @click="handleClickFollowUpDynamics">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-50/c39f4e7511d61e030ddececfb01dfefc.png">
                        <div class="menu_item_text">跟进动态</div>
                    </div>
                    <div class="custom_tab_popper_wrap">
                        <div class="custom_tab_popper_header">
                            <span class="popper_title">跟进动态</span>
                            <div class="flex_wrap">
                                <div v-if="projectFormDetail.approval_status===1"
                                     class="detail_handle_icon_wrap"
                                     @click="handleClickAddFollowUp">
                                    <i class="iconfont icon-xiejilu"></i>
                                    <span>写跟进</span>
                                </div>
                                <div v-if="projectFormDetail.approval_status===1"
                                     class="detail_handle_icon_wrap"
                                     @click="handleClickAddManagementRecords">
                                    <i class="iconfont icon-shangji"></i>
                                    <span>管理商机</span>
                                </div>
                                <el-popover placement="bottom-start"
                                            popper-class="records_filter_popper"
                                            ref="records_filter_popper"
                                            title="筛选"
                                            trigger="click"
                                            width="360">
                                    <div slot="reference" class="detail_handle_icon_wrap">
                                        <i class="iconfont icon-shaixuan"></i>
                                        <span>筛选</span>
                                    </div>
                                    <el-form :model="recordsFilterForm"
                                             label-position="top"
                                             size="small">
                                        <el-form-item label="类型">
                                            <el-select v-model="recordsFilterForm.type"
                                                       clearable
                                                       placeholder="请选择类型"
                                                       @change="handleRecordsFilterChange"
                                                       @clear="handleRecordsFilterChange">
                                                <el-option label="跟进商机" value="follow_up_project"></el-option>
                                                <el-option label="管理商机" value="manage_project"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="时间">
                                            <el-date-picker v-model="recordsFilterForm.dateRange"
                                                            end-placeholder="结束日期"
                                                            format="yyyy/MM/dd"
                                                            range-separator="～"
                                                            start-placeholder="开始日期"
                                                            type="daterange"
                                                            value-format="yyyy-MM-dd"
                                                            @change="handleRecordsFilterChange">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-form>
                                </el-popover>
                            </div>
                        </div>
                        <div class="custom_tab_popper_body">
                            <el-skeleton :count="3"
                                         :loading="popoverLoad"
                                         :throttle="500"
                                         animated>
                                <template slot="template">
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="width: 120px" variant="h3"/>
                                        <el-skeleton-item style="width: 62px" variant="text"/>
                                    </div>
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="height: 60px" variant="rect"/>
                                    </div>
                                </template>
                                <template>
                                    <ul class="relate_quotation_list">
                                        <li v-for="item in followUpDynamicsList" class="relate_quotation_item">
                                            <div class="flex_js_wrap">
                                                <div class="flex_wrap">
                                                    <el-popover :visible-arrow="false"
                                                                placement="bottom-start"
                                                                popper-class="user_card_popper"
                                                                trigger="hover"
                                                                width="282">
                                                        <template slot="reference">
                                                            <div class="user-avatar-btn">
                                                                <img :src="item.log_user&&item.log_user.user_avatar?item.log_user.user_avatar:defaultImg"
                                                                     alt=""/>
                                                                <span v-text="item.log_user.name"></span>
                                                            </div>
                                                        </template>
                                                        <PersonnelCard :userInfo="userInfo"/>
                                                    </el-popover>
                                                    <span class="create_time" v-text="item.created_date"></span>
                                                </div>
                                                <div :class="'log_type_'+item.type"
                                                     class="quotation_status"
                                                     v-text="item.type_name"></div>
                                            </div>
                                            <div class="follow_up_content">
                                                <p v-text="item.content.content"></p>
                                                <div class="detail_btn"
                                                     @click="handleClickManagementRecordsDetail(item)">
                                                    <span>详情</span>
                                                    <i class="el-icon-d-arrow-right"></i>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </el-skeleton>
                        </div>
                        <div class="custom_tab_popper_footer"></div>
                    </div>
                </el-popover>
                <el-popover :visible-arrow="false"
                            placement="left"
                            popper-class="custom_tab_popper"
                            ref="log_popover"
                            trigger="click"
                            width="360">
                    <div slot="reference" class="menu_item_wrap" @click="handleClickLogRecord">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-50/e771f39b9e0665fa189eb8b48f2d2ab6.png">
                        <div class="menu_item_text">日志</div>
                    </div>
                    <div class="custom_tab_popper_wrap">
                        <div class="custom_tab_popper_header">
                            <span class="popper_title">日志</span>
                        </div>
                        <div class="custom_tab_popper_body">
                            <el-skeleton :count="3"
                                         :loading="popoverLoad"
                                         :throttle="500"
                                         animated>
                                <template slot="template">
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="width: 180px" variant="h3"/>
                                    </div>
                                    <div class="flex_js_wrap mb_12">
                                        <el-skeleton-item style="height: 40px" variant="rect"/>
                                    </div>
                                </template>
                                <template>
                                    <ul class="relate_quotation_list">
                                        <li v-for="item in logRecordList" class="relate_quotation_item">
                                            <div class="flex_js_wrap">
                                                <div class="flex_wrap">
                                                    <el-popover :visible-arrow="false"
                                                                placement="bottom-start"
                                                                popper-class="user_card_popper"
                                                                trigger="hover"
                                                                width="282">
                                                        <template slot="reference">
                                                            <div class="user-avatar-btn">
                                                                <img :src="item.user_avatar?item.user_avatar:defaultImg"
                                                                     alt=""/>
                                                                <span v-text="item.user_name"></span>
                                                            </div>
                                                        </template>
                                                        <PersonnelCard :userInfo="userInfo"/>
                                                    </el-popover>
                                                    <span class="create_time" v-text="item.create_time"></span>
                                                </div>
                                            </div>
                                            <div class="follow_up_content">
                                                <p v-text="item.type==='project_group_update'?item.content.title:item.content.details"></p>
                                                <div class="detail_btn"
                                                     v-if="item.type==='project_group_update'&&item.content&&item.content.details"
                                                     @click="handleClickLogRecordsDetail(item)">
                                                    <span>详情</span>
                                                    <i class="el-icon-d-arrow-right"></i>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </el-skeleton>
                        </div>
                        <div class="custom_tab_popper_footer"></div>
                    </div>
                </el-popover>
            </div>
        </div>
        <el-dialog v-if="stageTaskDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :before-close="handleClickStageTaskDialogCancel"
                   :visible.sync="stageTaskDialogVisible"
                   class="custom_form_dialog custom-form-dialog"
                   title="填写阶段任务"
                   width="560px">
            <div class="custom_form_body">
                <CustomFormPc ref="stage_task_form"
                              :field_list="stageTaskFieldsList"
                              :is_form_module="true"
                              :form_detail="stageTaskFieldsFormDetail"
                              :pk_id="currentProjectStageId"
                              @submit-form="submitTaskFormData"/>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickStageTaskDialogCancel">取消</el-button>
                <el-button :disabled="btnDisabled"
                           size="small"
                           type="primary"
                           @click="handleClickStageTaskDialogConfirm">
                    确定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="logRecordsDetailVisible"
                   :before-close="handleClickLogRecordsDetailClose"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="logRecordsDetailVisible"
                   class="custom_form_dialog custom-form-dialog"
                   title="原商机阶段"
                   width="560px">
            <ul class="log_record_list">
                <li v-for="item in logRecordsDetail"
                    :key="item.project_stage_id"
                    class="log_record_item">
                    <div class="left_icon_wrap">
                        <i class="el-icon-time"></i>
                    </div>
                    <div class="right_contnet_wrap">
                        <h3 v-text="item.name"></h3>
                        <CustomFormDetailPc :field_list="item.tasks"
                                            :form_detail="item.form_detail"
                                            :pk_id="item.project_stage_id"/>
                    </div>
                </li>
            </ul>
        </el-dialog>
        <el-dialog v-if="failureRemarksDialog"
                   :before-close="handleClickFailureReasonCancel"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="failureRemarksDialog"
                   title="输单"
                   width="520px">
            <div class="reason_textarea_wrap">
                <div class="reason_label">输单原因</div>
                <el-input v-model="failureRemarks"
                          :rows="7"
                          maxlength="200"
                          placeholder="输单原因"
                          show-word-limit
                          type="textarea"></el-input>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickFailureReasonCancel">取消</el-button>
                <el-button :disabled="btnDisabled"
                           size="small"
                           type="primary"
                           @click="handleClickFailureReasonConfirm">
                    确定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog :before-close="handleClickInvalidReasonCancel"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   v-if="invalidRemarksDialog"
                   :visible.sync="invalidRemarksDialog"
                   title="无效"
                   width="520px">
            <div class="reason_textarea_wrap">
                <div class="reason_label">无效原因</div>
                <el-input v-model="invalidRemarks"
                          :rows="7"
                          maxlength="200"
                          placeholder="无效原因"
                          show-word-limit
                          type="textarea"></el-input>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickInvalidReasonCancel">取消</el-button>
                <el-button :disabled="btnDisabled"
                           size="small"
                           type="primary"
                           @click="handleClickInvalidReasonConfirm">
                    确定
                </el-button>
            </div>
        </el-dialog>
        <businessEdit v-if="editBusinessDialogVisible"
                      :dialogVisible.sync="editBusinessDialogVisible"
                      :project_id="project_id"
                      @refresh-list="getBusinessDetail"/>
        <addMember v-if="teamMembersAddVisible"
                   @refresh="getProjectMemberList"
                   :project_ids="[project_id]"
                   :dialogVisible.sync="teamMembersAddVisible"/>
        <OrderAdd v-if="addOrderDialogVisible"
                  :dialogVisible.sync="addOrderDialogVisible"
                  :project_data="project_data"
                  @refresh-list="handleClickRelateOrder"/>
        <changeThePerson v-if="changeThePersonDialogVisible"
                         :project_ids="[project_id]"
                         @refresh="getBusinessDetail"
                         :dialogVisible.sync=" changeThePersonDialogVisible"/>
        <followUpAdd v-if="addFollowUpVisible"
                     :customer_id="projectFormDetail.customer_id.value"
                     :project_id="project_id"
                     @refresh="handleClickFollowUpDynamics"
                     :dialogVisible.sync="addFollowUpVisible"/>
        <followUpDetail v-if="followUpRecordsDetailVisible"
                        :dialog-visible.sync="followUpRecordsDetailVisible"
                        :record_id="managementRecordsId"/>
        <managementRecordAdd v-if="addManagementRecordsVisible"
                             :project_id="project_id"
                             @refresh="handleClickFollowUpDynamics"
                             :dialogVisible.sync="addManagementRecordsVisible"/>
        <managementRecordDetail v-if="managementRecordsDetailVisible"
                                :dialog-visible.sync="managementRecordsDetailVisible"
                                :record_id="managementRecordsId"/>
        <quotationTemplate v-if="addQuotationDialogVisible"
                           :dialogVisible.sync="addQuotationDialogVisible"/>
    </div>
</template>
<script>
import {
    getFormFields,
    projectDetail,
    groupGetStageAndTask,
    stagePushInfoAutoSave,
    getAutoSaveStagePushInfo,
    stagePush,
    stageInfoUpdate,
    projectMemberList,
    projectMemberAuthEdit,
    projectMemberDel,
    projectGroupUpdateLogIsUnread,
    projectLogList,
    GetCustomerLogList,
    projectDel,
    projectQuotationListByProjectId,
    getOrderList,
    workOrderList
} from "@/api";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import businessEdit from "./component/business_edit";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import followUpAdd from "./component/follow_up_add";
import followUpDetail from "./component/follow_up_detail";
import managementRecordAdd from "./component/management_record_add";
import managementRecordDetail from "./component/management_record_detail";
import quotationTemplate from "./component/quotation_template";
import addMember from "./component/add_member";
import changeThePerson from "./component/change_the_person";
import OrderAdd from "@/views/pc/Order/component/order_add.vue";
import {EventBus} from "@/utils/eventBus";
import {mapGetters} from "vuex";

export default {
    name: "BusinessDetail",
    data() {
        return {
            loading: false,
            userInfo: {},
            elaborateOrRetract: false,
            formInfoList: [],
            projectFormDetail: {},
            dataLoaded: false,
            projectStagesList: [],
            stageTaskFormShow: false,
            businessStage: 1,
            failureRemarksDialog: false,
            failureRemarks: '',
            invalidRemarksDialog: false,
            invalidRemarks: '',
            formValidateRes: false,
            relateQuotationList: [], // 关联报价单
            relateOrderList: [], // 关联订单
            relateWorkOrderList: [], // 关联工单
            teamMembersList: [], // 团队成员
            followUpDynamicsList: [], // 跟进动态
            logRecordList: [], // 日志
            popoverLoad: false,
            teamMembersAddVisible: false,
            teamMembersAddForm: {
                member: '',
                authorization: 'read_write'
            },
            teamMembersAddFormRules: {
                member: [
                    {required: true, message: '请选择成员', trigger: 'blur'}
                ]
            },
            addFollowUpVisible: false,
            addManagementRecordsVisible: false,
            followUpRecordsDetailVisible: false,
            managementRecordsDetailVisible: false,
            managementRecordsId: 0,
            recordsFilterForm: {
                type: '',
                dateRange: []
            },
            addQuotationDialogVisible: false,
            defaultImg: require('@/assets/images/default.jpg'),
            project_id: Number(this.$route.query.project_id),
            stageTaskDialogVisible: false,
            stageTaskFieldsList: [], // 阶段任务字段
            stageTaskFieldsFormDetail: {}, //阶段任务详情
            editBusinessDialogVisible: false,
            currentProjectStageId: 0, // 当前阶段id
            currentStageSort: 0, // 当前阶段序号
            currentStageData: {}, // 当前阶段数据
            currentStageTaskFieldList: [],//当前阶段任务字段
            currentStageTaskFormDetail: {},// 当前阶段任务详情
            isStagePush: false, //是否为推进
            nextStageId: 0, // 下一阶段id
            changeThePersonDialogVisible: false,
            logRecordsDetailVisible: false,
            logRecordsDetail: [],
            addOrderDialogVisible: false,
            project_data: {},
            permission: {},
            btnDisabled: false,
        }
    },
    components: {
        OrderAdd,
        CustomFormDetailPc,
        CustomFormPc,
        businessEdit,
        PersonnelCard,
        followUpAdd,
        followUpDetail,
        managementRecordAdd,
        managementRecordDetail,
        quotationTemplate,
        addMember,
        changeThePerson,
    },
    computed: {
        ...mapGetters(['hasPermission']),
        hasDelPermission() {
            return this.hasPermission('project.del', 'customer', 'Project');
        },
    },
    created() {
        this.getBusinessDetail()
    },
    mounted() {
        projectGroupUpdateLogIsUnread({
            project_id: this.project_id
        }).then(res => {
            if (res.data && res.data.isUnread) {
                const h = this.$createElement;
                this.$msgbox({
                    title: '商机阶段发生变化',
                    message: h('p', null, [
                        h('span', null, '由于管理员更改了商机流程，该商机阶段发生变化，但'),
                        h('span', {style: 'fontWeight:bold'}, '原本填写的某些信息将会保留'),
                        h('span', null, '，可在日志中查看原阶段情况！'),
                    ]),
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-shuoming',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_warning'
                }).then(() => {
                    this.isStagePush = false
                }).catch(() => {
                    this.isStagePush = false
                })
            }
        })
    },
    methods: {
        // 展开/收起
        handleClickElaborateOrRetract() {
            this.elaborateOrRetract = !this.elaborateOrRetract
            if (this.elaborateOrRetract && this.formInfoList.length === 0) {
                this._getFromFields()
            }
        },

        //获取商机详情
        getBusinessDetail() {
            this.loading = true
            projectDetail({
                project_id: this.project_id,
            }).then(res => {
                if (res.code === 200) {
                    this.projectFormDetail = res.data
                    this.permission = res.data.permission
                    groupGetStageAndTask({
                        project_group_id: res.data.project_group_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.projectStagesList = res.data || []
                            if (this.projectStagesList.length) {
                                if (this.projectFormDetail.project_stage.value > 0) {
                                    this.currentStageData = this.projectStagesList.find(item => item.project_stage_id === this.projectFormDetail.project_stage.value)
                                    this.currentProjectStageId = this.projectFormDetail.project_stage.value
                                    this.currentStageTaskFieldList = this.currentStageData.tasks
                                    this.currentStageSort = this.currentStageData.sort
                                    if (this.currentStageTaskFieldList.length) {
                                        getAutoSaveStagePushInfo({
                                            project_id: this.project_id,
                                            project_stage: this.projectFormDetail.project_stage.value,
                                        }).then(res => {
                                            if (res.code === 200) {
                                                this.currentStageTaskFieldList.forEach(field => {
                                                    this.$set(field, 'is_edit', true)
                                                    if (this.projectFormDetail.hasOwnProperty(field.field_key)) {
                                                        this.$set(this.currentStageTaskFormDetail, field.field_key, this.projectFormDetail[field.field_key])
                                                    }
                                                    if (res.data && res.data.hasOwnProperty(field.field_key)) {
                                                        const field_value = res.data[field.field_key]
                                                        if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' || field_value.value !== undefined || field_value.value.length !== 0))) {
                                                            this.$set(this.currentStageTaskFormDetail, field.field_key, res.data[field.field_key])
                                                        }
                                                    }
                                                })
                                                this.stageTaskFormShow = true
                                            } else {

                                            }
                                        })
                                    }
                                } else {
                                    this.businessStage = this.projectFormDetail.project_stage.value
                                }
                            }
                        } else {

                        }
                        this.loading = false
                    })
                } else {

                    this.loading = false
                }
            })
        },

        // 获取表单字段
        _getFromFields() {
            getFormFields({
                field_form: 'projects'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data.filter(item => item.field_key !== 'name' && item.field_key !== 'salesperson' && item.field_key !== 'customer_id' && item.field_key !== 'project_stage')
                    this.dataLoaded = true
                } else {

                }
            }).catch(() => {
            })
        },

        //点击编辑商机
        handleClickEditBusiness() {
            this.editBusinessDialogVisible = true
        },

        //点击更换负责人
        handleClickChangeThePerson() {
            this.changeThePersonDialogVisible = true
        },

        //点击删除商机
        handleClickDelBusiness() {
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectDel({
                    project_id: [this.project_id]
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.$router.replace({
                            name: 'Business'
                        })
                    } else {

                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },

        //点击某个阶段
        handleClickStageItem(item) {
            this.currentStageSort = item.sort
            if (item.sort < this.currentStageData.sort) {
                this.stageTaskFormShow = false
                this.currentStageTaskFieldList = item.tasks
                this.currentStageTaskFormDetail = {}
                this.currentStageTaskFieldList.forEach(field => {
                    this.$set(this.currentStageTaskFormDetail, field.field_key, this.projectFormDetail[field.field_key])
                })
                this.$nextTick(() => {
                    this.stageTaskFormShow = true
                })
            } else if (item.sort === this.currentStageData.sort) {
                this.stageTaskFormShow = false
                this.currentStageTaskFieldList = item.tasks
                getAutoSaveStagePushInfo({
                    project_id: this.project_id,
                    project_stage: this.projectFormDetail.project_stage.value,
                }).then(res => {
                    if (res.code === 200) {
                        this.currentStageTaskFormDetail = res.data || {}
                        this.stageTaskFormShow = true
                    } else {

                    }
                })
            } else {
                this.projectStagesList.forEach((stage, stage_index) => {
                    if (stage.sort >= this.currentStageData.sort && stage.sort < item.sort && stage.tasks.length) {
                        const field = {
                            field_form: "projects",
                            field_key: stage.project_stage_id,
                            field_name: stage.name + '任务',
                            field_type: "form_module",
                            extend: {
                                is_form_show: true
                            },
                            sort: stage_index + 1,
                            _child: stage.tasks
                        }
                        this.stageTaskFieldsList.push(field)
                        field._child.forEach(child => {
                            if (this.projectFormDetail.hasOwnProperty(child.field_key)) {
                                this.$set(this.stageTaskFieldsFormDetail, child.field_key, this.projectFormDetail[child.field_key])
                            }
                            if (this.currentStageTaskFormDetail.hasOwnProperty(child.field_key)) {
                                const field_value = this.currentStageTaskFormDetail[child.field_key]
                                if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' || field_value.value !== undefined || field_value.value.length !== 0))) {
                                    this.$set(this.stageTaskFieldsFormDetail, child.field_key, this.currentStageTaskFormDetail[child.field_key])
                                }
                            }
                        })
                    }
                })
                if (this.stageTaskFieldsList.length) {
                    this.stageTaskDialogVisible = true
                } else {
                    this.stageTaskFormShow = false
                    this.currentStageTaskFieldList = item.tasks
                    this.$nextTick(() => {
                        this.stageTaskFormShow = true
                    })
                }
            }
        },

        //阶段任务取消事件
        handleClickStageTaskDialogCancel() {
            this.stageTaskDialogVisible = false
            this.stageTaskFieldsList = []
        },

        //阶段任务确定事件
        handleClickStageTaskDialogConfirm() {
            this.$refs.stage_task_form.handleClickPublish()
        },

        //获取阶段任务表单数据
        submitTaskFormData(data) {
            this.btnDisabled = true
            stagePush({
                project_id: this.project_id,
                project_stage: this.projectStagesList.find(item => item.sort === this.currentStageSort).project_stage_id,
                ...data
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('推进成功')
                    this.stageTaskDialogVisible = false
                    this.stageTaskFormShow = false
                    this.getBusinessDetail()
                } else {

                }
                this.btnDisabled = false
            })
        },

        // 点击推进下一阶段
        handleClickAdvanceNextStage() {
            this.isStagePush = true
            this.nextStageId = this.projectStagesList.find(item => item.sort > this.currentStageData.sort).project_stage_id
            if (this.stageTaskFormShow) {
                this.$refs.now_stage_task_detail_form.handleClickPublish()
            } else {
                stagePush({
                    project_id: this.project_id,
                    project_stage: this.nextStageId,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('推进成功！')
                        this.stageTaskFormShow = false
                        this.getBusinessDetail()
                        this.nextStageId = 0
                    }
                    this.btnDisabled = false
                })
            }
        },

        //点击赢单
        handleClickBusinessTriumph() {
            stagePush({
                project_id: this.project_id,
                project_stage: -1,
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('操作成功')
                    this.currentStageTaskFieldList = []
                    this.stageTaskFormShow = false
                    this.getBusinessDetail()
                } else {

                }
            })
        },

        // 点击输单
        handleClickBusinessFailure() {
            this.failureRemarksDialog = true
        },

        //输单取消
        handleClickFailureReasonCancel() {
            this.failureRemarksDialog = false
            this.failureRemarks = ''
            this.btnDisabled = false
        },

        // 输单确定
        handleClickFailureReasonConfirm() {
            if (this.failureRemarks.trim() === '') return this.$message.error('请输入输单原因！')
            this.btnDisabled = true
            stagePush({
                project_id: this.project_id,
                project_stage: -2,
                remarks: this.failureRemarks
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('操作成功')
                    this.currentStageTaskFieldList = []
                    this.stageTaskFormShow = false
                    this.btnDisabled = false
                    this.handleClickFailureReasonCancel()
                    this.getBusinessDetail()
                } else {

                }
            })
        },

        // 点击无效商机
        handleClickBusinessInvalid() {
            this.invalidRemarksDialog = true
        },

        // 无效商机取消
        handleClickInvalidReasonCancel() {
            this.invalidRemarksDialog = false
            this.invalidRemarks = ''
            this.btnDisabled = false
        },

        // 无效商机确定
        handleClickInvalidReasonConfirm() {
            if (this.invalidRemarks.trim() === '') return this.$message.error('请输入无效原因！')
            this.btnDisabled = true
            stagePush({
                project_id: this.project_id,
                project_stage: -3,
                remarks: this.invalidRemarks
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('操作成功')
                    this.currentStageTaskFieldList = []
                    this.stageTaskFormShow = false
                    this.btnDisabled = false
                    this.handleClickInvalidReasonCancel()
                    this.getBusinessDetail()
                } else {

                }
            })
        },

        //获取商机阶段表单数据
        submitDetailFormData(data) {
            this.btnDisabled = true
            this.formValidateRes = Object.keys(data).length > 0
            if (this.formValidateRes) {
                if (this.isStagePush) {
                    this.isStagePush = false
                    stagePush({
                        project_id: this.project_id,
                        project_stage: this.nextStageId,
                        ...data
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('推进成功！')
                            this.stageTaskFormShow = false
                            this.getBusinessDetail()
                            this.nextStageId = 0
                        } else {

                        }
                        this.btnDisabled = false
                    })
                } else {
                    if (this.currentStageSort < this.currentStageData.sort) {
                        stageInfoUpdate({
                            project_id: this.project_id,
                            ...data
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message.success('修改成功！')
                            } else {

                            }
                            this.btnDisabled = false
                        })
                    } else {
                        stagePushInfoAutoSave({
                            project_id: this.project_id,
                            project_stage: this.currentStageData.project_stage_id,
                            data
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message.success('保存成功！')
                            } else {

                            }
                            this.btnDisabled = false
                        })
                    }
                    this.formValidateRes = false
                }
            } else {
                if (this.isStagePush) {
                    this.$msgbox({
                        title: '推进至下一阶段',
                        message: '当前阶段有任务待完成，无法直接推进！',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        iconClass: 'iconfont icon-shuoming',
                        showCancelButton: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        customClass: 'icon_title_message_box icon_title_message_box_danger'
                    }).then(() => {
                        this.isStagePush = false
                        this.btnDisabled = false
                    }).catch(() => {
                        this.isStagePush = false
                    })
                }
            }
        },

        //点击关联商机报价单
        handleClickRelateQuotation() {
            this.popoverLoad = true
            projectQuotationListByProjectId({
                project_id: this.project_id
            }).then(res => {
                this.relateQuotationList = res.data
                this.popoverLoad = false
            })
        },

        // 点击查看报价单详情
        handleClickQuotationDetail(item) {
            this.$router.push({
                name: "QuotationDetails",
                params: {
                    isPush: true,
                },
                query: {
                    project_quotation_id: item.project_quotation_id,
                    name: item.quotation_num,
                },
            })
        },

        //点击新建报价单
        handleClickAddNewQuotation() {
            this.addQuotationDialogVisible = true
            const project_data = {
                project_id: this.project_id,
                project_name: this.projectFormDetail.name,
                customer_id: this.projectFormDetail.customer_id,
                contact_id: {
                    value: this.projectFormDetail.contact_id.value,
                    text: [this.projectFormDetail.contact_id.text && this.projectFormDetail.contact_id.text.length ? this.projectFormDetail.contact_id.text[0].name : ''],
                },
                contact_phone: {
                    value: this.projectFormDetail.contact_id.text && this.projectFormDetail.contact_id.text.length ? this.projectFormDetail.contact_id.text[0].phone : ''
                }
            }
            this.$store.dispatch('saveRelateProjectData', project_data)
            EventBus.$on('quotationUpdated', this.handleClickRelateQuotation);
        },

        //点击关联订单
        handleClickRelateOrder() {
            this.popoverLoad = true
            getOrderList({
                project_id: this.project_id,
                page: 1,
                pageSize: 100,
                status: 0
            }).then(res => {
                if (res.code === 200) {
                    this.relateOrderList = res.data.data
                    this.popoverLoad = false
                }
            })
        },

        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id,
                    name: row.order_num,
                },
            });
        },

        // 新建订单
        handleClickAddOrder() {
            this.project_data = {
                project_id: this.project_id,
                project_name: this.project_name,
            }
            this.addOrderDialogVisible = true
        },

        //点击关联工单
        handleClickRelateWorkOrder() {
            this.popoverLoad = true
            workOrderList({
                project_id: this.project_id,
                page: 1,
                pageSize: 100
            }).then(res => {
                this.relateWorkOrderList = res.data.data
                this.popoverLoad = false
            })
        },

        //点击工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },

        //点击团队成员
        handleClickTeamMember() {
            if (this.teamMembersList.length === 0) {
                this.popoverLoad = true
                this.getProjectMemberList()
            }
        },

        //获取团队成员列表
        getProjectMemberList() {
            projectMemberList({
                project_id: this.project_id
            }).then(res => {
                if (res.code === 200) {
                    this.popoverLoad = false
                    this.teamMembersList = res.data
                } else {
                    this.popoverLoad = false
                }
            })
        },

        //点击添加团队成员
        handleClickAddTeamMember() {
            this.teamMembersAddVisible = true
            this.$refs.team_members_popover.doClose()
        },

        //点击删除团队成员
        handleClickDeleteTeamMember(item) {
            this.$msgbox({
                title: '删除团队成员',
                message: '确定删除该成员吗？',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectMemberDel({
                    project_id: this.project_id,
                    member_uid: item.member_uid
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getProjectMemberList()
                    } else {

                    }
                })
            }).catch(() => {

            })
        },

        //团队成员权限编辑
        handleMemberAuthChange(item) {
            projectMemberAuthEdit({
                project_id: this.project_id,
                member_uid: item.member_uid,
                auth: item.auth
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('修改成功')
                    this.getProjectMemberList()
                } else {

                }
            })
        },

        //点击跟进动态
        handleClickFollowUpDynamics() {
            if (this.followUpDynamicsList.length === 0) {
                this.popoverLoad = true
                GetCustomerLogList({
                    project_id: this.project_id,
                    dateRange: this.recordsFilterForm.dateRange ? this.recordsFilterForm.dateRange.join(' - ') : '',
                    type: this.recordsFilterForm.type,
                    keyword: '',
                    modelSwitch: {}
                }).then(res => {
                    if (res.code === 200) {
                        this.followUpDynamicsList = res.data.list
                        this.popoverLoad = false
                    } else {

                        this.popoverLoad = false
                    }
                })
            }
        },

        //筛选事件
        handleRecordsFilterChange() {
            this.$refs.records_filter_popper.doClose()
            this.popoverLoad = true
            GetCustomerLogList({
                project_id: this.project_id,
                dateRange: this.recordsFilterForm.dateRange ? this.recordsFilterForm.dateRange.join(' - ') : '',
                type: this.recordsFilterForm.type,
                keyword: '',
                modelSwitch: {}
            }).then(res => {
                if (res.code === 200) {
                    this.followUpDynamicsList = res.data.list
                    this.popoverLoad = false
                } else {

                    this.popoverLoad = false
                }
            })
        },

        //点击添加跟进记录
        handleClickAddFollowUp() {
            this.addFollowUpVisible = true
        },

        //点击新增管理记录
        handleClickAddManagementRecords() {
            this.addManagementRecordsVisible = true
        },

        //点击跟进记录详情
        handleClickManagementRecordsDetail(item) {
            this.managementRecordsId = item.relate_id
            if (item.type === 'follow_up_project') {
                this.followUpRecordsDetailVisible = true
            } else {
                this.managementRecordsDetailVisible = true
            }
        },

        //点击日志
        handleClickLogRecord() {
            this.popoverLoad = true
            projectLogList({
                project_id: this.project_id
            }).then(res => {
                if (res.code === 200) {
                    this.logRecordList = res.data.data
                } else {

                }
            })
            this.popoverLoad = false
        },

        //显示原商机阶段详情
        handleClickLogRecordsDetail(item) {
            this.logRecordsDetail = item.content.details
            this.logRecordsDetail.forEach(log => {
                log.form_detail = {}
                log.tasks.forEach(field => {
                    this.$set(log.form_detail, field.field_key, field.field_value)
                })
            })
            this.logRecordsDetailVisible = true
        },

        handleClickLogRecordsDetailClose() {
            this.logRecordsDetailVisible = false
            this.logRecordsDetail = []
        }
    },
    beforeDestroy() {
        EventBus.$off('quotationUpdated', this.handleClickRelateQuotation);
    },
}
</script>
<style lang="scss" scoped>
.detail_outer_wrap {
    width: 100%;
    height: 100%;
    background-color: #EDF0F4;
    overflow: hidden;
    display: flex;
    gap: 4px;

    .left_detail_board {
        flex: 1;
        display: flex;
        flex-direction: column;

        .detail_top_wrap {
            background-color: #FFFFFF;
            padding: 16px;
            border-radius: 0 0 6px 0;
            position: relative;

            .loser_reason_wrap {
                padding: 8px 16px;
                line-height: 22px;
                border-radius: 4px;
                background: #FBE1E1;
                border: 1px solid #E44144;
                margin-bottom: 16px;

                .loser_title {
                    color: #E44144;
                }

                .loser_text {
                    color: #333333;
                }
            }

            .invalid_reason_wrap {
                padding: 8px 16px;
                line-height: 22px;
                border-radius: 4px;
                background: #E8E8E8;
                border: 1px solid rgba(217, 217, 217, 0.34);
                margin-bottom: 16px;

                .loser_title {
                    color: #333333;
                }

                .loser_text {
                    color: #333333;
                }
            }

            .flex_js_wrap {
                margin-bottom: 8px;
            }

            .icon-bumenfuzeren {
                color: #333333;
                display: inline-block;
                font-size: 14px;
            }

            .company_name {
                line-height: 22px;
                color: #666666;
                display: inline-block;
            }

            .create_date {
                color: #666666;
                line-height: 22px;
                display: inline-block;
            }

            ::v-deep .el-link {
                margin-left: 12px;
                line-height: 22px;

                .icon-xiajiantou {
                    font-size: 14px;
                }

                .icon-shangjiantou {
                    font-size: 14px;
                }
            }

            h2 {
                color: #333333;
                font-size: 18px;
                line-height: 28px;
            }

            .detail_form_wrap {
                margin-top: 12px;
            }

            .bottom_umbrage {
                width: 100%;
                height: 12px;
                border-radius: 0 0 6px 0;
                box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.08);
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }

        .detail_bottom_wrap {
            flex: 1;
            padding: 4px 0 4px 4px;
            display: flex;
            gap: 4px;
            overflow: hidden;

            .bottom_detail_wrap {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                background: #FFFFFF;
                padding: 20px 16px;

                .business_stage_wrap {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 16px;
                    border-bottom: 1px solid #E8E8E8;

                    .business_stage_list {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        gap: 22px;
                        border-radius: 6px;
                        overflow-x: auto;
                        scrollbar-width: none; /* Firefox 中隐藏 */
                        -ms-overflow-style: none; /* 旧版 IE */

                        &::-webkit-scrollbar {
                            display: none; /* 隐藏滚动条 */
                        }

                        .business_stage_item {
                            padding: 6px 12px;
                            min-width: 110px;
                            text-align: center;
                            cursor: pointer;
                            position: relative;
                            display: flex;
                            gap: 4px;
                            align-items: center;

                            .stage_index {
                                width: 22px;
                                height: 22px;
                                font-size: 12px;
                                line-height: 20px;
                                border: 1px solid #D9D9D9;
                                border-radius: 50%;
                                text-align: center;
                                vertical-align: middle;
                                color: #999999;
                            }

                            .stage_end {
                                width: 22px;
                                height: 22px;
                                font-size: 14px;
                                line-height: 22px;
                                border: 1px solid #2990FF;
                                border-radius: 50%;
                                text-align: center;
                                vertical-align: middle;
                                color: #2990FF;
                            }

                            .stage_title {
                                line-height: 22px;
                                color: #666666;
                                flex: 1;
                                white-space: nowrap;
                            }

                            .el-icon-arrow-right {
                                font-size: 12px;
                                color: #666666;
                                position: absolute;
                                right: -17px;
                            }

                            &.excessive_current_stage {
                                font-weight: bold;
                                color: #333333;

                                .stage_index {
                                    color: #FFFFFF;
                                    background-color: #2990FF;
                                }

                                .stage_title {
                                    color: #333333;
                                }

                                &::before {
                                    background-color: #2990FF;
                                }
                            }

                            &.current_stage {
                                border-bottom: 2px solid #2990FF;

                                .stage_title {
                                    font-weight: bold;
                                }
                            }

                            .stage_end_icon {
                                .iconfont {
                                    font-size: 14px;
                                    color: #FFFFFF;
                                }

                                .triumph_icon {
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 50%;
                                    text-align: center;
                                    line-height: 22px;
                                    background-color: #2990FF;
                                }

                                .failure_icon {
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 50%;
                                    text-align: center;
                                    line-height: 22px;
                                    background-color: #E44144;
                                }

                                .invalid_icon {
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 50%;
                                    text-align: center;
                                    line-height: 22px;
                                    background-color: #BFBFBF;
                                }
                            }
                        }

                        ::v-deep .el-dropdown {
                            position: sticky;
                            right: 0;
                        }

                        .business_end_stage {
                            z-index: 10;
                            background-color: #FFFFFF;
                            box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08), -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
                        }
                    }

                    ::v-deep .el-button {
                        padding: 2px 8px;
                        line-height: 18px;
                        border-radius: 4px;
                    }
                }

                .stage_task_form_wrap {
                    flex: 1;
                    overflow-y: auto;
                    overflow-x: hidden;

                    .custom_form_wrap {
                        padding: 0;
                    }
                }

                h3 {
                    line-height: 22px;
                    font-size: 14px;
                    margin-bottom: 16px;
                }

                .business_stage_detail_wrap {
                    height: calc(100% - 129px);
                    overflow-y: auto;
                    overflow-x: hidden;
                }
            }
        }
    }

    .right_menu_board {
        width: 80px;
        min-width: 80px;
        height: 100%;
        border-radius: 6px;
        background: #FFFFFF;
        padding: 16px 2px;

        .menu_item_wrap {
            text-align: center;
            padding: 8px 0;
            cursor: pointer;

            img {
                width: 28px;
                height: 28px;
                margin-bottom: 4px;
            }

            .menu_item_text {
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: #666666;
            }

            &:hover {
                background: rgba(0, 0, 0, 0.04);
            }
        }
    }
}

.reason_textarea_wrap {
    .reason_label {
        line-height: 22px;
        margin-bottom: 4px;
        color: #333333;
        position: relative;
        padding-left: 8px;

        &::before {
            content: '*';
            position: absolute;
            left: 0;
            color: #E44144;
        }
    }

    ::v-deep .el-textarea__inner {
        resize: unset;
    }
}

.log_record_list {
    padding: 24px;

    .log_record_item {
        display: flex;
        align-items: start;
        gap: 16px;
        padding-bottom: 8px;
        padding-top: 4px;

        &:first-child {
            padding-top: 0;
        }

        .left_icon_wrap {
            width: 24px;
            height: 24px;
            font-size: 14px;
            text-align: center;
            line-height: 24px;
            background-color: #2990FF;
            color: #FFFFFF;
            border-radius: 50%;
        }

        .right_contnet_wrap {
            padding: 12px;
            border-radius: 4px;
            background: #F7F8FA;
            flex: 1;

            h3 {
                font-size: 14px;
                margin-bottom: 12px;
            }
        }
    }
}
</style>
<style lang="scss">
.el-dropdown-menu .el-dropdown-menu__item:hover {
    background: rgba(41, 144, 255, 0.08);
    color: #2990FF;
}

.custom_tab_popper {
    padding: 0;
    border-radius: 6px 0 0 6px;

    .custom_tab_popper_wrap {
        height: 360px;
        display: flex;
        flex-direction: column;

        .custom_tab_popper_header {
            padding: 16px 16px 4px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .popper_title {
                font-size: 14px;
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }
        }

        .custom_tab_popper_body {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 0 16px;

            .el-skeleton {
                margin-top: 12px;
            }

            .relate_quotation_list {
                .relate_quotation_item {
                    padding: 12px 0;
                    border-bottom: 1px solid #E8E8E8;

                    .quotation_status {
                        line-height: 22px;
                        padding: 0 8px;
                        border-radius: 4px;

                        &.quotation_status_1 {
                            background-color: rgba(240, 170, 50, 0.1);
                            color: #F0AA32;
                        }

                        &.quotation_status_2 {
                            background-color: rgba(228, 65, 68, 0.1);
                            color: #E44144;
                        }

                        &.quotation_status_3 {
                            background-color: rgba(191, 191, 191, 0.1);
                            color: #BFBFBF;
                        }

                        &.quotation_status_4 {
                            background-color: rgba(240, 170, 50, 0.1);
                            color: #F0AA32;
                        }

                        &.quotation_status_5 {
                            background-color: rgba(191, 191, 191, 0.1);
                            color: #BFBFBF;
                        }

                        &.quotation_status_6 {
                            background-color: rgba(90, 179, 51, 0.1);
                            color: #5AB333;
                        }

                        &.quotation_status_7 {
                            background-color: rgba(228, 65, 68, 0.1);
                            color: #E44144;
                        }

                        &.log_type_follow_up_project {
                            background: rgba(240, 170, 50, 0.1);
                            color: #F0AA32;
                        }

                        &.log_type_manage_project {
                            background: rgba(41, 144, 255, 0.1);
                            color: #2990FF
                        }
                    }

                    .el-col {
                        margin-top: 4px;
                    }

                    .form_item_label {
                        font-size: 12px;
                        line-height: 18px;
                        color: #999999;
                    }

                    .form_item_value {
                        font-size: 12px;
                        line-height: 18px;
                        color: #333333;
                    }

                    .create_time {
                        font-size: 12px;
                        line-height: 18px;
                        color: #666666;
                    }

                    .follow_up_content {
                        padding: 8px;
                        background-color: #EDF0F4;
                        border-radius: 4px;
                        margin-top: 4px;
                        position: relative;

                        p {
                            font-size: 12px;
                            line-height: 18px;
                            color: #666666;
                        }

                        .detail_btn {
                            box-shadow: -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
                            background: #EDF0F4;
                            position: absolute;
                            right: 8px;
                            bottom: 8px;
                            color: #2990FF;
                            font-size: 12px;
                            line-height: 18px;
                            cursor: pointer;
                            z-index: 10;
                        }
                    }
                }
            }

            .team_members_list {
                .team_members_item {
                    padding: 12px 0;
                    border-bottom: 1px solid #E8E8E8;

                    .el-radio-group {
                        margin-right: 16px;
                    }

                    .el-radio {
                        margin-right: 16px;

                        .el-radio__label {
                            padding-left: 8px;
                        }
                    }
                }
            }
        }

        .custom_tab_popper_footer {
            width: 100%;
            height: 16px;
            box-shadow: 0 -2px 4px -2px rgba(0, 0, 0, 0.08);
            border-radius: 0 0 0 6px;
        }
    }
}

.records_filter_popper {
    padding: 16px;

    .el-popover__title {
        margin-bottom: 16px;
    }

    .el-select, .el-date-editor--daterange.el-input__inner {
        width: 100%;
    }
}
</style>